import { Box, Button, TableContainer, Table, ButtonGroup, TableHead, TableRow, TableCell, TableBody, Paper, Typography } from '@mui/material'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { Config, fetchAllConfigsAsync, pickConfig, selectAllConfig } from './AdminSlice'
import { Delete, Edit } from '@mui/icons-material'
import { grey } from '@mui/material/colors'
import { useNavigate, useParams } from 'react-router-dom'

const AdminConfig = () => {
  const { mode } = useParams()
  const dispatch = useAppDispatch()
  const configs = useAppSelector(selectAllConfig)
  const navigate = useNavigate()
  return (<Box sx={{ textAlign: 'left' }}>
    <ButtonGroup>
      <Button variant='outlined' color='success' onClick={() => {
        navigate(`/admin/config/${mode}/new`)
      }}>
        New Config
      </Button>
      <Button onClick={() => {
        dispatch(fetchAllConfigsAsync({ mode: mode ? mode : 'regular' }))
      }}>Load all Config</Button>
    </ButtonGroup>
    <Typography variant='h4' sx={{ color: grey[700], marginBottom: 3, marginTop: 3 }}>
      {mode}
    </Typography>
    {configs?.content?.length > 0 && <Box sx={{ marginBottom: 5 }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Key</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>&nbsp;</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configs?.content.map((config: any) => <>
              <TableRow key={config.appConfigId}>
                <TableCell scope="row" sx={{ borderBottom: 'none' }}>
                  {config.key}
                </TableCell>
                <TableCell sx={{ borderBottom: 'none', whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '300px' }}>{config.value}</TableCell>
                <TableCell sx={{ borderBottom: 'none' }}>
                  <ButtonGroup>
                    <Button variant='outlined' color='info' onClick={() => {
                      dispatch(pickConfig(config))
                      navigate(`/admin/config/${mode}/edit/${config.key}`)
                    }}>
                      <Edit />
                    </Button>
                    <Button variant='outlined' color='error' onClick={() => {
                      dispatch(pickConfig(config))
                      navigate(`/admin/config/${mode}/delete/${config.key}`)
                    }}>
                      <Delete />
                    </Button>
                  </ButtonGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography variant='caption' sx={{ color: grey[700] }}>
                    {config.description}
                  </Typography>
                </TableCell>
              </TableRow>
            </>)}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>}

  </Box>
  )
}

export default AdminConfig
